import React from "react";
import { Navigate } from "react-router-dom";
import { useUserContext } from "../context/UserContext";
import { MenteeContextProvider } from "../context/MenteeContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useUserContext();

  if (!user?.token) {
    return <Navigate to="/" />;
  }
  return <MenteeContextProvider>{children}</MenteeContextProvider>;
};

export default ProtectedRoute;
